import { AnalyticsEventTopic, typeMapping } from '../analyticsHelper';
import { AnalyticsWeightings } from '../analyticsWeightings';
import { CoveoAnalyticsCustomData, CoveoAnalyticsEvent, CoveoEventType } from './coveoEventType';

interface CoveoSearchEvent extends CoveoAnalyticsEvent {
    actionCause: string;
    queryText: string;
    responseTime: number;
    searchQueryUid: string;
    contextual: boolean;
    withResults: boolean;
    numberOfResults: number;
    advancedQuery: string;
    queryPipeline: string;
    originLevel1: string;
    originLevel2?: string;
    customData: CoveoAnalyticsCustomData;
}

export class SearchCoveoEventType extends CoveoEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_SEARCH_DONE;
    }

    // @ts-expect-error * Automated Type Error Fix
    getBody(event): CoveoSearchEvent {
        const coveoAttributes = event.searchContext;
        const baseEvent = this.baseBody(event);
        const { originLevel1, originLevel2, numberOfResults } = coveoAttributes;
        const originLevels = Object.assign({}, originLevel1 && { originLevel1 }, originLevel2 && { originLevel2 });
        return {
            ...baseEvent,
            outcome: AnalyticsWeightings.searchPoints,
            queryPipeline: coveoAttributes.queryPipeline,
            searchQueryUid: coveoAttributes.searchQueryUid,
            actionCause:
                coveoAttributes.actionCause ||
                this.actionCause(coveoAttributes.type, Boolean(coveoAttributes.queryText)),
            contextual: coveoAttributes.contextual,
            withResults: numberOfResults > 0,
            numberOfResults,
            responseTime: coveoAttributes.duration,
            advancedQuery: coveoAttributes.advancedQuery,
            queryText: coveoAttributes.queryText || '',
            ...originLevels,
            customData: {
                ...baseEvent.customData,
            },
        };
    }

    actionCause(type: string, isKeyword: boolean): string {
        const prefix = !isKeyword ? 'RcmdSearch' : '';
        if (!type) {
            return 'interfaceLoad';
        }
        return `${typeMapping(type)}${prefix}`;
    }

    getPath(): string {
        return 'search';
    }
}
